import { GENERIC_HEADER, GENERIC_MULTIPART_HEADER } from "../shared/utils/Constants";

export abstract class RestService {

    public abstract readonly apiVersion: string;
    public SEGNALAZIONI_SERVICE_BASE_URL: string;
    public CATALOG_SERVICE_BASE_URL: string;
    public LOI_SERVICE_BASE_URL: string;
    public TRIAGE_SERVICE_BASE_URL : string;
    public REPORT_SERVICE_BASE_URL : string;

    constructor() {
        this.SEGNALAZIONI_SERVICE_BASE_URL = 'stor';
        this.CATALOG_SERVICE_BASE_URL = 'catalogs';
        this.LOI_SERVICE_BASE_URL = 'lineOfInquiry';
        this.TRIAGE_SERVICE_BASE_URL = 'triage'
        this.REPORT_SERVICE_BASE_URL = 'reports'
    }

    public createHttpGenericOptions() {
        const headers = GENERIC_HEADER;
        return headers;
    }

    public createHttpMultipartGenericOptions() {
        const headers = GENERIC_MULTIPART_HEADER;
        return headers;
    }


    public createHttpAuthOptions(jwt: string) {
        const headers ={
            'Content-Type': 'application/json',
            // 'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': 'true',
            'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
            'X-Content-Type-Options': 'nosniff',
            'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
            'Authorization': 'Bearer ' + jwt
        };

        return headers
    }
}
